<template>
  <div class="w-full">
    <div class="supplier rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/settings/delivery-methods')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                     @click="deleteDeliveryMethod(delivery_method.id)">Delete</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="editDeliveryMethod(delivery_method.id)">Edit</el-button>
          <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                     @click="$router.push('/ecommerce/settings/delivery-methods/new')">New</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Name:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6">{{ delivery_method.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Shipper:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6" v-if="delivery_method.shipper">{{ delivery_method.shipper.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Delivery max. miles:</div></el-col>
        <el-col :span="12"><div class="px-4 mb-6">{{ delivery_method.delivery_max_miles }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Delivery initial mile:</div></el-col>
        <el-col :span="12"><div class="px-4 mb-6">{{ delivery_method.delivery_init_miles }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Delivery initial mile cost:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6">₦{{ delivery_method.delivery_init_mile_cost }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Delivery additional mile cost:</div></el-col>
        <el-col :span="12"><div class="px-4 mb-6">₦{{ delivery_method.delivery_additional_mile_cost }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Free delivery max. miles:</div></el-col>
        <el-col :span="12"><div class="px-4 mb-6">{{ delivery_method.free_delivery_max_miles }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Free delivery minimum amount:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6">₦{{ delivery_method.free_delivery_min_amount }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Default:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6">
            <template v-if="delivery_method.default === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"><div class="px-4 mb-6 hd">Enabled:</div></el-col>
        <el-col :span="12">
          <div class="px-4 mb-6">
            <template v-if="delivery_method.status === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DeliveryMethodDetails',
  computed: {
    delivery_method() {
      return this.$store.state.SettingsModule.DeliveryMethods.delivery_method;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('SettingsModule/DeliveryMethods/getDeliveryMethod', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    editDeliveryMethod(id) {
      this.$router.push(`/ecommerce/settings/delivery-methods/${id}/edit`);
    },
    deleteDeliveryMethod(deliveryMethodId) {
      this.$confirm('Are you sure you want to delete this delivery method?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/DeliveryMethods/deleteDeliveryMethod', { deliveryMethodId });
          this.$notify.success({
            title: 'Success',
            message: 'Delivery method has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
